import { AlignTypes } from "@monorepo-web/components-library";
export const getLayouts = (periodo) => {
    const columns = {
        'default': [
            {
                id: 'ativo',
                label: 'Ativo',
                freeze: true,
            },
            {
                id: 'mes',
                label: 'Mês',
                align: AlignTypes.right,
            },
            {
                id: 'ano',
                label: 'Ano',
                align: AlignTypes.right,
            },
            {
                id: 'mes12',
                label: '12 meses',
                align: AlignTypes.right,
            },
            {
                id: 'mes24',
                label: '24 meses',
                align: AlignTypes.right,
            },
        ],
        'reduzido': [
            {
                id: 'ativo',
                label: 'Nome do Ativo',
                freeze: true,
            },
            {
                id: 'mes',
                label: 'Retorno Mês Atual',
                align: AlignTypes.right,
            },
            {
                id: 'ano',
                label: 'Retorno Ano Atual',
                align: AlignTypes.right,
            },
            {
                id: 'mes12',
                label: 'Retorno 12M',
                align: AlignTypes.right,
            },
            {
                id: 'periodo',
                label: 'Retorno Início',
                align: AlignTypes.right,
            },
        ]
    };
    if (periodo && periodo !== '12m' && periodo !== '24m' && periodo !== 'mes_atual') {
        columns['default'].push({
            id: 'periodo',
            label: periodo === 'maximo' ? 'Desde o início' : 'Período',
            align: AlignTypes.right,
        });
    }
    return columns;
};
